export const useAppContext = () => {
    const isReady = ref(false)
    const hasError = ref(false)

    const bootstrap = async () => {
      try {
        const cmsStore = useCmsStore()
        const sportCategoryStore = useSportCategoryStore()
        const tournamentStore = useTournamentStore()
        const clubStore = useClubStore()
        const menuStore = useMenuStore()

        await Promise.all([
          cmsStore.fetch(),
          sportCategoryStore.fetch(),
          tournamentStore.popular(),
          tournamentStore.fetch(),
          clubStore.popular()
        ])

        menuStore.build()
        isReady.value = true

        return isReady.value
      } catch (e) {
        console.error('Bootstrap error:', e)
        hasError.value = true
      }
    }

    return {
      isReady,
      hasError,
      bootstrap
    }
  }
